let socket = null;

export const connectWebSocket = (url, onMessageCallback) => {
  socket = new WebSocket(url);

  socket.addEventListener("open", (event) => {
    // console.log("WebSocket connected:", event);
  });

  socket.addEventListener("message", (event) => {
    const data = JSON.parse(event.data);
    // console.log("Received message:", data);
    if (onMessageCallback) {
      onMessageCallback(data); // 回调处理消息
    }
  });

  socket.addEventListener("error", (error) => {
    console.error("WebSocket error:", error);
  });

  socket.addEventListener("close", (event) => {
    // console.log("WebSocket closed:", event);
  });
};

export const sendWebSocketMessage = (message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not connected");
  }
};

export const closeWebSocket = () => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.close(1000, "Normal closure");
  }
};

// const webSocket = {
//   webSocketInstance: null,
//   heartbeatTime: null,
//   reconnectTime: null,
//   // 初始化webSocket
//   initWebSocket: function () {
//     if ("WebSocket" in window) {
//       this.webSocketInstance = new WebSocket(
//         `${process.env.VUE_APP_SOCKET_PATH}/joker/ws/${localStorage.getItem(
//           "token"
//         )}`
//       );
//       this.webSocketInstance.onopen = this.webSocketOpen;
//       this.webSocketInstance.onerror = this.webScoketError;
//       this.webSocketInstance.onmessage = this.webSocketMessage;
//       this.webSocketInstance.onclose = this.webSocketClose;
//     }
//   },
//   // 监听socket 链接成功
//   webSocketOpen: function () {
//     // // console.log("webSocket 链接成功");
//   },
//   // 监听socket 链接失败
//   webScoketError: function () {
//     // // console.log("webSocket 链接失败");
//     webSocket.reconnectSocket();
//   },
//   webSocketMessage: function ({ data }) {
//     // // console.log("收到消息");
//     // console.log(data);
//   },
//   webSocketClose: function () {
//     // console.log("webSocket 关闭链接");
//   },
//   // 重连
//   reconnectSocket: function () {
//     // // console.log("断线重连");
//     this.reconnectTime = setTimeout(() => {
//       this.initWebSocket();
//     }, 5000);
//   },
// };
//
// export default webSocket;
// src/utils/websocket.js
